import React, { useEffect, useRef, useState } from 'react'
import OutgoingPayment from './OutgoingPayment'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import api from '../../api'
import _, { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal, SuccessModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { formatNumber } from '../../utils/formatNumber'
import { useTranslation } from 'react-i18next'

const JournalEntries = () => {
	const navigation = useNavigate()
	const { t } = useTranslation()
	const errorRef = useRef()
	const successRef = useRef()
	const { getMe } = useSelector((state) => state.main)

	const [isLoading, setIsLoading] = useState(false)
	const [startDate, setStartDate] = useState(
		moment().startOf('month').format('YYYY-MM-DD'),
	)
	const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'))
	const [accCode, setAccCode] = useState('')
	const [pagination, setPagination] = useState({
		page: 0,
	})
	const [cashAccountsData, setCashAccountsData] = useState([])

	const [data, setData] = useState({
		data: [],
	})
	const search = (acc) => {
		setIsLoading(true)
		const url =
			`/JournalEntries?$filter=U_NumDoc eq 'Send Money'` +
			`${getMe?.Department2.Name === 'Sotuv' ? ` and U_Creator eq ${getMe?.EmployeeID}` : ''}` +
			` and ReferenceDate ge '${startDate}T00:00:00.000Z'` +
			` and ReferenceDate le '${endDate}T23:59:59.999Z'` +
			`&$skip=${pagination.page * 20}&$orderby=BaseReference desc`
		api
			.get(url, {
				headers: {
					Prefer: 'odata.maxpagesize=20',
				},
			})
			.then((res) => {
				const resData = JSON.parse(res.data).value
				setData({
					data: [...resData],
				})
				setIsLoading(false)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
				setIsLoading(false)
			})
	}

	const cashAccounts = async () => {
		const data = await api(
			`ChartOfAccounts?$select=Code,Name&$filter=ExternalCode eq '1' or ExternalCode eq '11'`,
			{
				headers: {
					Prefer: 'odata.maxpagesize=10000',
				},
			},
		).then((res) => {
			return JSON.parse(res.data).value
		})
		setCashAccountsData(data)
	}

	useEffect(() => {
		search()
	}, [startDate, pagination, endDate])
	useEffect(() => {
		cashAccounts()
	}, [])

	const newDatas = () => {
		if (data.data.length < 20) {
			alert('Никакой другой информации')
		} else {
			setPagination((prev) => ({ ...prev, page: prev.page + 1 }))
		}
	}

	const oldData = () => {
		if (pagination.page > 0) {
			setPagination((prev) => ({ ...prev, page: prev.page - 1 }))
		} else {
			alert('Никакой другой информации')
		}
	}

	const handleStartDateChange = (event) => {
		setStartDate(event.target.value)
	}
	const handleEndDateChange = (event) => {
		setEndDate(event.target.value)
	}

	const handleCardCodeChange = _.debounce((e) => {
		search({ cardCode: e.target.value })
	}, 1000)

	const handleCardNameChange = _.debounce((e) => {
		search({ cardName: e.target.value })
	}, 1000)

	return (
		<Layout>
			<OutgoingPayment>
				<div className="container">
					<p className="productTitle">{t('journalEntries')}</p>
					<div className="flex justify-between items-end m-5">
						<div className="searchCard mt-8">
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									{t('startDate')}
								</p>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									value={startDate}
									onChange={handleStartDateChange}
								/>
							</div>
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									{t('endDate')}
								</p>
								<input
									type="date"
									className={
										'border-[1px] border-[#DFE2E9"] p-1 rounded-md w-full'
									}
									value={endDate}
									onChange={handleEndDateChange}
								/>
							</div>
						</div>
						<Button
							btnStyle={{ width: 'max-content', padding: '0 10px' }}
							onClick={() => navigation('/journal-entries/create')}
						>
							{t('add')}
						</Button>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-y-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												{t('docNum')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('date')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('fromCash')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('toSeyf')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('price')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('currency')}
											</th>
											<th scope="col" className="px-6 py-4">
												{t('comment')}
											</th>
										</tr>
									</thead>
									<tbody>
										{data.data.map((v, i) => {
											const accCode = get(
												v.JournalEntryLines[0],
												'AccountCode',
												'',
											)
											const accName = cashAccountsData.find(
												(item) => item.Code === accCode,
											)?.Name
											const contrAccCode = get(
												v.JournalEntryLines[0],
												'ContraAccount',
												'',
											)
											const contrAccName = cashAccountsData.find(
												(item) => item.Code === contrAccCode,
											)?.Name

											return (
												<tr
													className="bg-white border-b  hover:bg-gray-50 "
													key={i}
												>
													<td className="px-6 py-4 whitespace-nowrap">
														{get(v, 'Number', '')}
													</td>
													<td className="px-6 py-4">
														{moment(get(v, 'ReferenceDate', '')).format(
															'DD-MM-YYYY',
														)}
													</td>
													<td className="px-6 py-4 whitespace-nowrap">
														{`${contrAccCode} - ${contrAccName}`}
													</td>
													<td className="px-6 py-4">
														{`${accCode} - ${accName}`}
													</td>
													<td className="px-6 py-4">
														{get(v.JournalEntryLines[0], 'FCCurrency', '') ===
														'UZS'
															? formatNumber(
																	get(v.JournalEntryLines[0], 'FCDebit', ''),
																)
															: formatNumber(
																	get(v.JournalEntryLines[0], 'Debit', ''),
																)}
													</td>
													<td className="px-6 py-4">
														{get(v.JournalEntryLines[0], 'FCCurrency', '') ||
															'USD'}
													</td>

													<td className="px-6 py-4">{get(v, 'Memo', '')}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div style={{ alignItems: 'center' }} className="flex">
									<Button onClick={oldData} btnStyle={{ marginRight: 10 }}>
										{'<'}
									</Button>
									<p style={{ marginRight: '10px' }}>{pagination.page + 1}</p>
									<Button onClick={newDatas}>{'>'}</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</OutgoingPayment>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						successRef.current = r
					}}
				/>
			</>
		</Layout>
	)
}

export default JournalEntries
